.footer {
    border-top: 1px solid var(--tl-border);
    padding: 40px 26px 22px;
    margin-top: auto;
}

.topRow {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    gap: 26px;
    max-width: 1200px;
    margin: 0 auto;
}

.brandLink {
    display: flex;
    align-items: center;
    gap: 9px;
}

.domain {
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -0.02em;
    color: var(--tl-text);
    text-transform: lowercase;
}

.tld {
    color: var(--tl-dim);
    font-weight: 400;
}

.tagline {
    margin-top: 10px;
    font-size: 13px;
    color: var(--tl-muted);
    max-width: 32ch;
    line-height: 1.6;
}

.statusRow {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 7px;
}

.statusDot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--tl-accent);
    box-shadow: 0 0 8px rgba(255, 223, 168, 0.6);
}

.statusLabel {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: var(--tl-dim);
}

.linkCol {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.colHeading {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9.5px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--tl-dim);
    margin-bottom: 3px;
}

.link {
    font-size: 13px;
    color: var(--tl-muted);
}

.separator {
    max-width: 1200px;
    margin: 26px auto 0;
    border-top: 1px solid var(--tl-border);
}

.bottomRow {
    max-width: 1200px;
    margin: 16px auto 0;
    display: flex;
}

.copyright {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: var(--tl-dim);
    letter-spacing: 0.04em;
}

@media (max-width: 900px) {
    .topRow {
        grid-template-columns: 1fr 1fr;
        row-gap: 30px;
    }
}

@media (max-width: 560px) {
    .topRow {
        grid-template-columns: 1fr;
    }
}
